import { useAuth0 } from "@auth0/auth0-react";
import {useEffect} from "react";
import {authTokenProvider} from "./AuthTokenProvider";

export default function AuthProviderBridge() {
    const { getAccessTokenSilently, logout } = useAuth0();

    useEffect(() => {
        authTokenProvider.initialize(getAccessTokenSilently,logout);
    }, [getAccessTokenSilently, logout]);

    return null;
}